
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
const OperatorTable = ({ setUpdateData, setGetTxnData }) => {
    const [data, setData] = useState([])
    const [data1, setData1] = useState([])
    const [servicesType, setservicesType] = useState('')
    const token = localStorage.getItem('token');

    console.log({ servicesType });
    const [searchOpt, setOpt] = useState('')
    useEffect(() => {

        const fetchData = async () => {
            await axios.get(`https://bharatdarshan.app/api/operator/get-operator-data?operatorType=${servicesType === undefined || servicesType == '' ? '' : servicesType?.name}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((res) => {
                if (res?.data?.data?.length !== 0) {
                    setData(res?.data?.data)
                }

                console.log({ data });
            })
        }

        fetchData()




    }, [servicesType])

    const handleEdit = (item) => {
        setGetTxnData(item)
        setUpdateData('Update')
    }
    const filteredData = data.filter(item => {
        if (!searchOpt) {
            return true; // Show all data when searchOpt is empty
        }
        const lowerCaseSearchOpt = searchOpt.toLowerCase();
        return (
            item?.city?.toLowerCase().includes(lowerCaseSearchOpt) ||
            item?.servicesType?.toLowerCase().includes(lowerCaseSearchOpt) ||
            item?.OperatorName?.toLowerCase().includes(lowerCaseSearchOpt) ||
            item?.OperatorCode?.toLowerCase().includes(lowerCaseSearchOpt)
        );
    });
    console.log({ filteredData });
    const handleExportToExcel = () => {
        const filteredDataForExcel = filteredData.map((item, index) => ({
            "Sl. No.": index + 1,
            City: item.city,
            "Operator Type": item.servicesTypeDetails.name,
            "Operator Name": item.OperatorName,
            "Operator Code": item.OperatorCode,

        }));

        const ws = XLSX.utils.json_to_sheet(filteredDataForExcel);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Operators');
        XLSX.writeFile(wb, 'Operators.xlsx');
    };
    useEffect(() => {
        const fetchData1 = async () => {
            const response = await axios.get(`https://bharatdarshan.app/api/operator/get-operator-services-type`, {
                headers: {
                    Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjY2NzNkOWNmYzZjZTMyMjMyZjhjMGIxZCJ9LCJpYXQiOjE3MTkzMDM3NDEsImV4cCI6MTcyNDQ4Nzc0MX0.EpRjCdx8bLF8UMjIy6PfeMfMxpDtgYDLuDDRmpzq8mc`
                }
            })
            if (response?.data?.data?.length !== 0) {
                setData1(response?.data?.data)
                // setservicesType1(response?.data?.data[0]?.name)
                // console.log({ response: response?.data?.data[0]?.name });
            }



        }
        fetchData1()
    }, [])
    return (
        <>
            <div className="row">
                <div className="col align-self-end">
                    <button onClick={() => setUpdateData('Create')} >Add Operator</button>
                    <button onClick={() => handleExportToExcel()} >Download</button>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-3">
                    <select className="form-select" onChange={(e) => setservicesType(data1.find(item => item._id === e.target.value))} >
                        <option value="" selected>Choose Operator</option>
                        {
                            data1?.map((item, index) => {
                                return (
                                    <option value={item._id} key={index}>{item?.name}</option>
                                )
                            })
                        }

                    </select>
                </div>
                <div className="col-lg-3">
                    <input type="text" className="form-control" onChange={(e) => setOpt(e.target.value)} placeholder="Search Here" />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Sl. No.</th>
                                <th>City</th>
                                <th>OperatorType</th>
                                <th>Min.Amount</th>
                                <th>Max.Amount</th>
                                <th>OperatorName</th>
                                <th>OperatorCode</th>
                                <th>operator Icon</th>
                                <th>Action</th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                filteredData?.map((item, index) => {
                                    console.log({ item });
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.city}</td>
                                            <td>{item.servicesTypeDetails.name}</td>
                                            <td>{item.minAmount}</td>
                                            <td>{item.maxAmount}</td>
                                            <td>{item.OperatorName}</td>
                                            <td>{item.OperatorCode}</td>
                                            <td>
                                                <img src={item.operatorImage} height={50} alt="Operator Icon" />
                                            </td>
                                            <td>
                                                <button onClick={() => handleEdit(item)}>Edit</button>
                                                <button>Delete</button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                </div>
            </div>

        </>
    )
}

export default OperatorTable
